import {DataCategorySelectItem} from './data-category-select-item';

export const DATA_CATEGORY_SELECT_DATA: DataCategorySelectItem[] = [
  {
    id: 'Traffic Information',
    label: 'Traffic Information',
  },
  {
    id: 'Roadworks and Road Conditions',
    label: 'Roadworks and Road Conditions',
  },
  {
    id: 'Traffic Flow Information',
    label: 'Traffic Flow Information',
  },
  {
    id: 'Parking Information',
    label: 'Parking Information',
  },
  {
    id: 'Electromobility',
    label: 'Electromobility',
  },
  {
    id: 'Traffic Signs and Speed Information',
    label: 'Traffic Signs and Speed Information',
  },
  {
    id: 'Weather Information',
    label: 'Weather Information',
  },
  {
    id: 'Public Transport Information',
    label: 'Public Transport Information',
  },
  {
    id: 'Shared and On-Demand Mobility',
    label: 'Shared and On-Demand Mobility',
  },
  {
    id: 'Infrastructure and Logistics',
    label: 'Infrastructure and Logistics',
  },
  {
    id: 'Various',
    label: 'Various',
  },
];
